var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrissCrossLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 25,
    viewBox: "0 0 348 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.3988C30.193 11.0463 57.2808 7.174 84.6616 5.59095C154.465 1.55521 224.727 2.68335 294.541 5.90552C306.87 6.47456 319.187 7.50772 331.534 7.60418C334.802 7.62972 338.893 6.95989 342.04 8.1704C347.034 10.0912 344.71 8.25967 339.712 7.85584C312.915 5.69039 284.408 8.67258 257.673 10.1207C205.942 12.9228 154.198 17.3858 102.403 18.8657C86.4858 19.3205 102.013 18.8642 108.694 18.9915C146.288 19.7076 184.055 19.8255 221.561 22.3259",
    stroke: "url(#paint0_linear_2255_4048)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2255_4048",
    x1: -30.8386,
    y1: 23.4024,
    x2: -28.8102,
    y2: -12.4833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#921A98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#E50624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC0004"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrissCrossLine);
export default __webpack_public_path__ + "static/media/crissCrossLine.ab6dda0a.svg";
export { ForwardRef as ReactComponent };